module.exports = __webpack_public_path__ + "static/media/errorAstronaut.1143d6a2.png";